import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BaseResponse } from "../_types";

export type GetReconciliationFileStatusRequest = {
  date?: string;
  bankCode?: string;
};

export type ReconciliationFileStatus = {
  bankCode: string;
  bankName: string;
  fileName: string;
  description: string;
  status: "START" | "FAIL" | "SUCCESS";
  createDate: string;
  updateDate: string;
};

export type GetReconciliationFileStatusResponse = BaseResponse<Array<ReconciliationFileStatus>>;

async function getReconciliationFileStatus(
  data: GetReconciliationFileStatusRequest
): Promise<GetReconciliationFileStatusResponse> {
  try {
    return (await axiosInstance.get("/Reconciliation/ListReconciliationFileStatus")).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetReconciliationFileStatus() {
  return useMutation<GetReconciliationFileStatusResponse, Error, GetReconciliationFileStatusRequest>((variables) =>
    getReconciliationFileStatus(variables)
  );
}
